import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import imageUrls from '../images/imageUrls';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { EndpointKey } from '../http/EndpointKey';
import { setLoadingStatus } from '../store/loading-status/action-creators';
import { LoadingKey } from '../app-active-loading/LoadingKey';
import { getPortalId } from '../store/auth/selectors';
import { getHublet, getIsNewUser } from '../store/app/selectors';
import { redirectToUrl } from '../utils/redirectToUrl';
import { getFallbackOnboardingUrl } from '../signup-completed-redirection/getFallbackOnboardingUrl';
import { MetricsCounter } from '../metrics/MetricsCounter';
import { Metrics } from '../metrics/Metrics';
import { getEndpointRetries } from '../store/http-responses/selectors';
import { Tracker } from '../store/tracking/action-creators';

const MissingBlogIdeasGeneratorScopesView = () => {
  const dispatch = useDispatch();
  const portalId = useSelector(getPortalId);
  const hublet = useSelector(getHublet);
  const isNewUser = useSelector(getIsNewUser);
  const retryNumberBlogScopesEndpoint = useSelector(state => getEndpointRetries(state, EndpointKey.CheckScopesForBlogIdeasGeneratorNewUser));

  const onButtonClick = () => {
    setLoadingStatus(LoadingKey.StandardLoading);
    Metrics.counter(MetricsCounter.RetryBlogScopesEndpoint, {
      retryNumber: `${retryNumberBlogScopesEndpoint + 1}`
    }).increment();
    dispatch(Tracker.signupInteraction('retry-blog-settings-endpoint'));
    dispatch(retryEndpoint(EndpointKey.CheckScopesForBlogIdeasGeneratorNewUser));
  };

  const onLinkClick = () => {
    dispatch(Tracker.signupInteraction('abort-blog-ideas-generator-redirect'));
    dispatch(redirectToUrl(getFallbackOnboardingUrl(portalId, hublet, isNewUser)));
  };

  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: ErrorKey.MissingBlogIdeasGeneratorScopesError,
    handleButtonClick: onButtonClick,
    handleLinkClick: onLinkClick,
    imageURL: imageUrls.computerSprocket
  });
};

export default MissingBlogIdeasGeneratorScopesView;